<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section12.vue?689c657c